// Compare user-entered draft state, not derived credit/banners or upload progress.
// A confirmed launch must never erase a replacement draft or steal its context.
export function composerSendDraftKey(draft) {
  if (!draft) return null;
  const fields = ['text', 'selectedParameters', 'selectedButtons', 'selectedModelIds', 'selectedAgentIds',
    'botId', 'quote', 'editFileIds', 'agentSelectionTouched', 'modelSelectionTouched', 'userExplicitAutoMode'];
  return JSON.stringify([fields.map(key => draft[key]), (draft.files || []).map(file => typeof file === 'string' ? file : file?.id)]);
}
export function retainComposerSendDraft({ store, auth, contextId }) {
  const account = auth.getState(), userId = account.user?.id, generation = account._sessionGeneration;
  const expectedDraft = composerSendDraftKey(store.getState().inputStates[contextId]);
  return result => Promise.resolve(result).then(accepted => {
    const current = auth.getState();
    if (accepted === true && userId && current.token && !current._isSigningOut &&
        current.user?.id === userId && current._sessionGeneration === generation && expectedDraft !== null)
      store.getState().clearInput(false, { contextId, expectedDraft });
    return accepted === true;
  }, () => false);
}
